import Store from '@/store'

export class ConfigBackendUtils {

    static fetchConfigs() {
        return Store.dispatch("backend-store/fetchConfigs");
    }

    static getConfigContent(configName) {
        return Store.dispatch("backend-store/getConfigContent", configName);
    }

    static deleteConfig(value) {
        return Store.dispatch("backend-store/deleteConfig", value);
    }

    static deleteConfigs(values) {
        return Store.dispatch("backend-store/deleteConfigs", values);
    }

    static setConfigAudience(value) {
        return Store.dispatch("backend-store/setConfigAudience", value);
    }

    static setConfigClientVersion(value) {
        return Store.dispatch("backend-store/setConfigClientVersion", value);
    }

    static setConfigMaster(value) {
        return Store.dispatch("backend-store/setConfigMaster", value);
    }

    static setConfigInfo(value) {
        return Store.dispatch("backend-store/setConfigInfo", value);
    }

    //GETTERS
    static getConfigs() {
        return Store.getters["backend-store/getConfigs"];
    }

     static deployConfig(value, uid) {
         return Store.dispatch("backend-store/deployConfig", {value, uid});
     }
}